export type SubjectFieldOptionPayload = { readonly value: string; readonly label: string };

export type SubjectFieldDefinitionPayload = {
	readonly key: string;
	readonly label: string;
	readonly nature: { readonly value: string; readonly label: string };
	readonly options: readonly SubjectFieldOptionPayload[];
	readonly required: boolean;
};

export type SubjectSpeakerRolePayload = { readonly key: string; readonly label: string };

export type SubjectTypePayload = {
	readonly id: number;
	readonly key: string;
	readonly wording: {
		readonly singular: string;
		readonly plural: string;
		readonly createAction: string;
		readonly emptyList: string;
		readonly sheetTitle?: string | null;
		readonly aboutLabel: string;
		readonly titleLabel: string;
	};
	readonly icon: { readonly value: string; readonly label: string };
	readonly color: { readonly value: string; readonly label: string };
	readonly informationMode: { readonly value: string; readonly label: string };
	readonly level: { readonly value: string; readonly label: string };
	readonly fields?: readonly SubjectFieldDefinitionPayload[];
	readonly about?: readonly { readonly value: string; readonly label: string }[];
	readonly speakerRoles?: readonly SubjectSpeakerRolePayload[];
};

export type SubjectTypesFetchedPayload = {
	accountId: number;
	types: SubjectTypePayload[];
};

export type SubjectTypesFetchedAction = {
	type: 'SUBJECT_TYPES_FETCHED';
	payload: SubjectTypesFetchedPayload;
};

export default (accountId: number, types: SubjectTypePayload[]): SubjectTypesFetchedAction => ({
	type: 'SUBJECT_TYPES_FETCHED',
	payload: { accountId, types },
});
